import { AssetManager } from 'components/sharpr/assetManager/AssetManager';
// import { ApiResourcify } from 'components/sharpr/api/ApiResourcify';

export function EmailAutoEmailReportRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.EmailAutoEmailReport', {
		url: '/auto_emails/:id',
		controllerAs: 'vm',
		controller: EmailAutoEmailReportCtrl,
		templateUrl: '/ng/hub/Email/AutoEmail/Report/EmailAutoEmailReportCtrl.html?' + window.BUILD,
		resolve: {
			$title: () => 'Notifications Report',
		},
	});
}

export class EmailAutoEmailReportCtrl {
	constructor(Api, $filter, $stateParams, $state) {
		'ngInject';
		this.Api = Api;
		this.$filter = $filter;
		this.$state = $state;
		this.autoEmailLimit = 10;
		this.emailSearchFilters = {
			type: 'auto',
			auto_email_id: $stateParams.id,
		};

		this.transformEmailItems = this.transformEmailItems.bind(this);
		this.sendToReport = this.sendToReport.bind(this);
		this.edit = this.edit.bind(this);
	}

	getEmailStats(emailId) {
		return new Promise((resolve, reject) => {
			this.Api.get(`/emails/${emailId}/stats?summary_only=true`).then(stats => resolve(stats));
		});
	}

	async transformEmailItems(response) {
		var dateFormat = this.$filter('shDate');
		var stats = await Promise.all(response.data.map(email => this.getEmailStats(email.id)));
		response.data = response.data.map((email, idx) => {
			const emailStats = stats[idx];

			email.recipient_count = emailStats.summary.total_recipients;
			email.open_count = emailStats.summary.total_opens;
			email.click_count = emailStats.summary.total_clicks;

			email.created = dateFormat(email.created, 'long');

			return email;
		});

		return response;
	}

	sendToReport(emailInRow) {
		window.location.href = this.$state.href('hub.loggedin.EmailReport', { id: emailInRow.id });
	}

	convertToStory(emailInRow) {
		window.location.href = `/stories/email_to_story/${emailInRow.id}`;
	}

	edit(emailInRow) {
		window.location.href = `/posts/email_publish?orig_type=${emailInRow.status}&orig_id=${emailInRow.id}`;
	}
}
